import Vue from 'vue'
import Router from 'vue-router'
import routes from './router'
import store from '@/store'
import iView from 'view-design'

Vue.use(Router)
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const originalPush = Router.prototype.push

Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start()
  if (to.matched.some(res => res.meta.norequirelogin)) {
    next()
  } else {
    if (store.state.user.hasGetInfo) {
      next()
    } else {
      store.dispatch('getUserInfo').then(() => {
        // 拉取用户信息，通过用户权限和跳转的页面的name来判断是否有权限访问;access必须是一个数组，如：['super_admin'] ['super_admin', 'admin']
        next()
      }).catch(() => {
        store.dispatch('handleLogOut')
        next({
          name: 'login'
          // params: { redirect: from.fullPath }
        })
      })
    }
  }

})
router.afterEach(() => {
  iView.LoadingBar.finish()
})
export default router
